import styled, { css } from 'styled-components';
import InputBase from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import THEME from '../../../../constants/theme';

export const CustomCheckboxesWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 16px;

  > div {
    width: 100%;

    > label {
      position: relative;
    }
  }
`;

const StyledOptionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 6px;
  width: 100%;
  justify-content: space-between;
`;

export const CustomCheckboxesStyled = styled.div`
  margin-bottom: 8px;
  width: 100%;
  @media (min-width: ${THEME.breakPoints.tablet}px) {
    width: calc(50% - 4px);
  }

  > label {
    position: relative;
    display: flex;
    width: 100%;
    padding: 16px;
    cursor: pointer;
    transition: 0.25s;
    border: 1px solid ${THEME.greyColors.grey16};
    background-color: white;
    border-radius: 6px;

    > div {
      position: relative;
      width: 20px;
      height: 20px;
      border-radius: 4px;
      box-sizing: border-box;
      border: 1px solid ${THEME.greyColors.grey300};
      transition: 0.15s;
      display: inline-flex;
      justify-content: space-around;
      align-items: center;
      font-size: 14px;
      color: white;
      margin-right: 12px;
      top: 1px;
      flex-shrink: 0;

      > img, svg {
        display: block;
        width: 10px;
        height: auto;
      }
    }

    &:hover {
      border-color: ${THEME.greyColors.grey300};
    }
  }
  }

  input {
    opacity: 0;
    height: 0;
    width: 0;
  }

  ${({ checked }) =>
    checked &&
    css`
      > label {
        background-color: ${THEME.primaryColors.primaryLight};
        border-color: ${THEME.primaryColors.primary};
        :hover {
          border-color: ${THEME.primaryColors.primary};
        }
        > div {
          border-color: #4545e9;
          background-color: #4545e9;
          /* &::after {
            content: '✔';
          } */
        }
      }
    `};
  ${({ focused }) =>
    focused &&
    css`
      > label {
        border-color: ${THEME.greyColors.grey300};
      }
    `};
`;

const StyledInputLabel = styled(InputLabel)`
  &.MuiFormLabel-root {
    color: initial;
    line-height: 20px;
    font-weight: 600;
  }

  &.Mui-focused {
    color: #3f51b5;
  }

  &.MuiInputLabel-shrink {
    transform: translate(0, 1.5px);
  }
`;

const StyledInput = styled(InputBase)`
  &.MuiInputBase-root {
    label + & {
      margin-top: 30px;
    }
  }

  .MuiInputBase-input {
    position: relative;
    height: 18px;
    padding: 10px 16px;
    border: 1px solid transparent;
    border-radius: 6px;
    background-color: #f5f6f7;
    line-height: 18px;
    transition-property: border-color, box-shadow;
    transition-duration: 0.3s;

    &:focus {
      border-color: #3023c8;
    }
  }
`;
export { StyledInput, StyledInputLabel, StyledOptionsWrapper };
